module.exports = __webpack_public_path__ + "img/truelab_white.a2d9da66.svg";